/* pill-sync.js
 * Keeps the inventory pill the same height as the price/sale pill
 * and aligns it vertically to that pill on each product card.
 */
(function () {
  // Selector for the price/sale badge inside the card
  var PRICE_BADGE_SEL = [
    '.card__content--badge .badge',
    '.card__content--badge .product__badge',
    '.card__content--badge [class*="badge-"]',
    '.card__content--badge .product-badge__item'
  ].join(',');

  function applyToCard(card) {
    if (!card || card.nodeType !== 1) return;

    var media     = card.querySelector('.card__media');
    var price     = card.querySelector(PRICE_BADGE_SEL);
    var invWrap   = card.querySelector('.card-inventory-badge');
    var invPill   = card.querySelector('.card-inventory-badge .product__inventory');

    if (!media || !price || !invWrap || !invPill) return;

    // Measure
    var priceRect = price.getBoundingClientRect();
    var mediaRect = media.getBoundingClientRect();

    // Drive height: tell the card the price pill height
    var h = Math.max(0, Math.round(priceRect.height));
    card.style.setProperty('--price-pill-h', h + 'px');

    // Align vertically: compute top offset of price-pill relative to image
    var topOffset = Math.max(8, Math.round(priceRect.top - mediaRect.top));
    card.style.setProperty('--price-pill-top', topOffset + 'px');
  }

  function scan(root) {
    (root || document).querySelectorAll('product-card .product-card, .product-card').forEach(applyToCard);
  }

  // Initial + on resize/load (images/fonts can affect size)
  window.addEventListener('DOMContentLoaded', function(){ scan(); });
  window.addEventListener('load', function(){ scan(); });
  window.addEventListener('resize', function(){ scan(); });

  // Watch for new cards (infinite scroll)
  var observeRoot = document.querySelector('infinite-scroll') || document.body;
  if (window.MutationObserver && observeRoot) {
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(n){
          if (n.nodeType !== 1) return;
          if (n.matches && (n.matches('product-card .product-card') || n.matches('.product-card'))) {
            applyToCard(n);
          } else {
            scan(n);
          }
        });
      });
    });
    mo.observe(observeRoot, { childList: true, subtree: true });
  }

  // Expose a manual trigger (optional)
  window.syncPillAlignment = function(){ scan(); };
})();
